module.exports = __webpack_public_path__ + "img/18-days-voyage.6b992087.jpg";